import { SessionRole, Inserter, Wrapper, PartAdminMenu, SpirisConnection } from "nystem-components";

const PartAdmin = () => (
  <Inserter match="/admin*">
    <SessionRole userrole="config super">
      <Wrapper className="overflow-hidden rounded-xl border border-stone-200 bg-white shadow-sm md:flex">
        <Wrapper className="border-b border-stone-200 bg-stone-50 p-2 md:min-w-56 md:border-b-0 md:border-r md:p-3">
          <PartAdminMenu />
        </Wrapper>
        <Wrapper className="min-w-0 grow px-5 pb-16 pt-5 md:px-8">
          <Inserter match="/admin">
            <SpirisConnection />
          </Inserter>
          <Inserter match="/admin/content*" source="/content*" />
          <Inserter match="/admin/user*" source="/user*" />
          <Inserter match="/admin/page*" source="/page*" />
          <Inserter match="/admin/article*" source="/article*" />
          <Inserter match="/admin/language*" source="/language*" />
          <Inserter match="/admin/translation*" source="/translation*" />
          <Inserter match="/admin/tag*" source="/tag*" />
          <Inserter match="/admin/menu*" source="/menu*" />
        </Wrapper>
      </Wrapper>
    </SessionRole>
  </Inserter>
);

export default PartAdmin;
